/* TWM blog article: table of contents, table wrappers, reading progress.
   The article reads fine without this script. */
(function () {
  const body = document.querySelector('[data-twm-article-body]');
  if (!body) return;

  // Wide tables scroll inside their own box instead of the page.
  body.querySelectorAll('table').forEach((table) => {
    if (table.closest('.twm-table')) return;
    const wrap = document.createElement('div');
    wrap.className = 'twm-table';
    table.parentNode.insertBefore(wrap, table);
    wrap.appendChild(table);
  });

  // Pasted posts often mark headings as bold paragraphs; leave those alone
  // and build the contents list from real h2s only.
  const toc = document.querySelector('[data-twm-toc]');
  const headings = Array.from(body.querySelectorAll('h2')).filter((h) => h.textContent.trim().length > 0);
  const links = [];

  if (toc && headings.length >= 3) {
    const list = toc.querySelector('ol');
    const used = new Set();

    headings.forEach((heading) => {
      let id = heading.id;
      if (!id) {
        const base =
          heading.textContent
            .trim()
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-|-$/g, '')
            .slice(0, 60) || 'section';
        id = base;
        let n = 2;
        while (used.has(id) || document.getElementById(id)) id = base + '-' + n++;
        heading.id = id;
      }
      used.add(id);

      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = '#' + id;
      link.textContent = heading.textContent.trim();
      item.appendChild(link);
      list.appendChild(item);
      links.push(link);
    });

    toc.hidden = false;

    // Open in the desktop sidebar; folded above the post on phones.
    const details = toc.querySelector('details');
    const narrow = window.matchMedia('(max-width: 989px)');
    const syncOpen = () => {
      if (details) details.open = !narrow.matches;
    };
    syncOpen();
    narrow.addEventListener('change', syncOpen);

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            links.forEach((link) => link.removeAttribute('aria-current'));
            const active = links.find((link) => link.hash === '#' + entry.target.id);
            if (active) active.setAttribute('aria-current', 'true');
          });
        },
        { rootMargin: '-20% 0px -70% 0px' }
      );
      headings.forEach((heading) => observer.observe(heading));
    }
  }

  const bar = document.querySelector('[data-twm-progress]');
  if (!bar || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  let ticking = false;
  const update = () => {
    const rect = body.getBoundingClientRect();
    const total = rect.height - window.innerHeight * 0.5;
    const done = Math.min(Math.max(-rect.top, 0), Math.max(total, 1));
    bar.style.transform = 'scaleX(' + done / Math.max(total, 1) + ')';
    ticking = false;
  };

  window.addEventListener(
    'scroll',
    () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    },
    { passive: true }
  );
  update();
})();
